import React from 'react';
import { ArrowForward } from "../../icons";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography";
import styles from "./MenuPromotionalAction.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MenuPromotionalAction(props) {
  const {
    title,
    body,
    testId,
    intent,
    onClick
  } = props;
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: !!tooltipFromIntent,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
      "data-testid": testId,
      placement: "top",
      title: tooltipFromIntent || '',
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    }),
    children: /*#__PURE__*/_jsxs("button", {
      className: styles.root,
      "data-testid": testId,
      disabled: disabledFromIntent,
      onClick: onClick,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          skin: "primary",
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: body
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.iconWrapper,
        children: /*#__PURE__*/_jsx(ArrowForward, {})
      })]
    })
  });
}